// extracted by mini-css-extract-plugin
export var background__darkNavy = "Wrapper-module--background__darkNavy--dc6d8";
export var background__grey = "Wrapper-module--background__grey--80a01";
export var background__neutralNavy = "Wrapper-module--background__neutralNavy--e9613";
export var background__sand = "Wrapper-module--background__sand--672c8";
export var lgBreak = "1200";
export var marginTop__lg = "Wrapper-module--margin-top__lg--7f740";
export var marginTop__md = "Wrapper-module--margin-top__md--9fd49";
export var marginTop__sm = "Wrapper-module--margin-top__sm--590b1";
export var marginTop__xs = "Wrapper-module--margin-top__xs--dd0cc";
export var mdBreak = "992";
export var paddingBottom__lg = "Wrapper-module--padding-bottom__lg--b2513";
export var paddingBottom__md = "Wrapper-module--padding-bottom__md--e86b8";
export var paddingBottom__sm = "Wrapper-module--padding-bottom__sm--f28a6";
export var paddingBottom__xs = "Wrapper-module--padding-bottom__xs--8ec46";
export var paddingTop__lg = "Wrapper-module--padding-top__lg--fa75e";
export var paddingTop__md = "Wrapper-module--padding-top__md--c6b1d";
export var paddingTop__sm = "Wrapper-module--padding-top__sm--4b894";
export var paddingTop__xs = "Wrapper-module--padding-top__xs--71400";
export var smBreak = "768";
export var wrapper = "Wrapper-module--wrapper--76cfa";
export var xsBreak = "480";